
import Vue from 'vue';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import VideoPlayer from '@owc-packages/VideoPlayer/src/VideoPlayer.vue';
import {
  HotspotSidepanelItemComponent,
  HotspotSidepanelItemComputed,
  HotspotSidepanelItemData,
  HotspotSidepanelItemMethods,
  HotspotSidepanelItemProps,
} from '@owc-packages/Hotspot/src/HotspotSidepanelItem.d';
import { getFootnotesIfAvailable } from '@owc-utils/Footnotes/FootnotesUtils';
import { TestId } from '@owc-utils/TestIdDirective';
import { transformToUnifiedMediaFormat } from './HotspotUtils';
import { TrackingInstance } from '@owc-packages/Tracking/src/Tracking.d';
import { CUSTOM_EVENTS as VIDEO_EVENTS } from '@owc-packages/VideoPlayer/src/VideoPlayer.config';
import initializeTracking, { formatTrackingString } from '@owc-packages/Tracking/src/TrackingUtils';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { isAemEditMode } from '@owc-utils/AEM';
import { mountFootnotes, setModuleId } from '@owc-utils/Footnotes/FootnotesHelper';
let trackingInstance: TrackingInstance | null = null;

/**
 * TODO: Documentation
 * Hotspot Sidepanel
 *
 * A Sidepanel to be placed in the HotspotSimpleItem.
 */
export default (Vue as HotspotSidepanelItemComponent).extend<
  HotspotSidepanelItemData,
  HotspotSidepanelItemMethods,
  HotspotSidepanelItemComputed,
  HotspotSidepanelItemProps
>({
  name: 'owc-hotspot-sidepanel-item',
  props: {
    item: {
      type: Object,
      required: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    wbSlideEvent: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GenericImage,
    VideoPlayer,
    ValidationBoxWrapper,
  },
  data: () => ({
    isCurrentVideoPlaying: false,
    currentVideoPlayButton: null,
  }),
  directives: {
    TestId,
  },
  async mounted() {
    trackingInstance = await initializeTracking();
    if (!this.mobile) {
      this.$nextTick(() => {
        if (this.isVideo) {
          this.$el.addEventListener(VIDEO_EVENTS.ready, this.autoPlayCurrentVideo);
        }
      });
    }
    this.$el.addEventListener(VIDEO_EVENTS.start, () => {
      this.isCurrentVideoPlaying = true;
    });
    this.$el.addEventListener(VIDEO_EVENTS.stop, () => {
      this.isCurrentVideoPlaying = false;
    });
    if (this.wbSlideEvent) {
      this.stopVideo();
    }
    this.$nextTick(() => {
      if (this.$parent && this.$parent.$parent && this.$parent.$el instanceof HTMLElement) {
        mountFootnotes(this.$parent && this.$parent.$parent);
      }
    });
  },
  computed: {
    mediaData() {
      return transformToUnifiedMediaFormat(this.item.media);
    },
    hasMedia() {
      return Boolean(this.item.media?.image);
    },
    isVideo() {
      return Boolean(this.item.media?.video);
    },
    link() {
      return this.item.link;
    },
    isEditMode() {
      return isAemEditMode(this.$parent!);
    },
    footnotesDataJson() {
      return getFootnotesIfAvailable({ footnotes: this.item.footnotes })?.footnotes;
    },
    moduleId() {
      return setModuleId(this.item.component);
    },
  },
  methods: {
    customButtonTrackingTrigger() {
      if (trackingInstance && this.item && this.link) {
        const headline = this.$refs.headline.textContent || '';
        trackingInstance.customTrackingObjectUpdate(
          {
            label: `cta.${formatTrackingString(this.link.label)}.${formatTrackingString(headline)}`,
            category: 'link',
          },
          'click',
          this.$refs.button,
        );
      }
    },
    getCurrentVideo() {
      const wrapper = this.$refs.sidepanelMedia as Element;
      if (this.isVideo) {
        const playButton = wrapper.querySelector(
          '.owc-video-player__play-button, .plyr--playing [data-plyr="play"]',
        ) as HTMLButtonElement;
        if (playButton) {
          this.currentVideoPlayButton = playButton;
        }
      }
    },
    autoPlayCurrentVideo() {
      this.getCurrentVideo();
      this.currentVideoPlayButton?.click();
    },
    stopVideo() {
      this.getCurrentVideo();
      this.currentVideoPlayButton?.click();
    },
  },
});
